import {connect} from 'react-redux';
import actionCreators from 'actionCreators';
import {updatePreferences} from 'actionCreators/preferences';
import {findSection, updateSectionValue} from 'ducks/reportSections';
import CustomiseComparableRentals from './CustomiseComparableRentals';

const mapStateToProps = (state) => {
  const reportType = state.reportType.value;
  const section = findSection(state.reportSections, reportType, 'COMPARABLE_RENTALS');
  return {
    section,
    reportType,
    selectedComparableRentals: state.comparableRentals.selected.filter(id => !state.comparableRentals.featured.includes(id)),
    featuredProperties: state.comparableRentals.selected.filter(id => state.comparableRentals.featured.includes(id)),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendEvent: (section, title) => {
      dispatch(actionCreators.sendEditTitleAnalyticsEvent(section, title));
    },
    updateValue: (value, dataKeyPath, reportType) => {
      dispatch(updateSectionValue({value, reportType, key: 'COMPARABLE_RENTALS', dataKeyPath: `sectionData.${dataKeyPath}`}));
    },
    updatePreferences: (preferences, reportType) => {
      dispatch(updatePreferences(preferences, reportType));
    }
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    updateSectionValue: (value, dataKeyPath) => {
      dispatchProps.updateValue(value, dataKeyPath, stateProps.reportType);
      dispatchProps.sendEvent(stateProps.section, value);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps) (CustomiseComparableRentals);
